import React, { useState } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Textarea } from "../../components/ui/textarea";
import { Checkbox } from "../../components/ui/checkbox";
import { Button } from "../../components/ui/button";
import { PlusCircle, RotateCcw } from "lucide-react";

const CampaignForm = ({ onCreate }) => {
  const [name, setName] = useState("Premium лояльность");
  const [description, setDescription] = useState("Сканируй QR на кассе → получи бонус + выбор: Max, Telegram, SMS");
  const [image, setImage] = useState("https://placehold.co/400x160?text=SVG+Card");
  const [logo, setLogo] = useState("🏆 LoyaClub");
  const [collectCustomUtm, setCollectCustomUtm] = useState(true);
  const [customSource, setCustomSource] = useState("");
  const [customMedium, setCustomMedium] = useState("");
  const [customCampaign, setCustomCampaign] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const utmSource = collectCustomUtm && customSource ? customSource : "qr_cashier";
    const utmMedium = collectCustomUtm && customMedium ? customMedium : "qr_physical";
    const utmCampaign = collectCustomUtm && customCampaign ? customCampaign : "loyalty_card";

    onCreate({
      name,
      description,
      image,
      logo,
      utmSource,
      utmMedium,
      utmCampaign,
      tags: ["cashier_qr", "loyalty"],
    });
  };

  const handleReset = () => {
    setName("Новая кампания");
    setDescription("Описание...");
    setImage("https://placehold.co/400x160");
    setLogo("🎁 Бонус");
    setCustomSource("");
    setCustomMedium("");
    setCustomCampaign("");
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <div className="h-8 w-8 rounded-xl bg-blue-50 flex items-center justify-center text-blue-600">
            <PlusCircle className="h-5 w-5" />
          </div>
          Создать кампанию
        </CardTitle>
        <CardDescription>Заполните данные для новой QR-страницы</CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="name">Название страницы</Label>
            <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required />
          </div>
          <div className="space-y-2">
            <Label htmlFor="description">Описание (на мини-лендинге)</Label>
            <Textarea id="description" value={description} onChange={(e) => setDescription(e.target.value)} rows={2} />
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div className="space-y-2">
              <Label htmlFor="image">Изображение (URL)</Label>
              <Input id="image" value={image} onChange={(e) => setImage(e.target.value)} placeholder="https://..." />
            </div>
            <div className="space-y-2">
              <Label htmlFor="logo">Логотип (эмодзи/текст)</Label>
              <Input id="logo" value={logo} onChange={(e) => setLogo(e.target.value)} placeholder="🏆 LoyaClub" />
            </div>
          </div>

          <div className="bg-slate-50 p-4 rounded-xl border space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-slate-500">⚡ Авто-метки (источник)</span>
              <span className="text-[11px] font-mono bg-white px-2 py-0.5 rounded-full shadow-sm">utm_source=qr_cashier</span>
            </div>
            <div className="flex items-center space-x-2">
              <Checkbox
                id="collectCustomUtm"
                checked={collectCustomUtm}
                onCheckedChange={(checked) => setCollectCustomUtm(checked)}
              />
              <Label htmlFor="collectCustomUtm" className="text-sm">Добавить кастомные UTM</Label>
            </div>
            {collectCustomUtm && (
              <div className="grid grid-cols-3 gap-2 mt-2">
                <Input placeholder="source" value={customSource} onChange={(e) => setCustomSource(e.target.value)} className="text-xs" />
                <Input placeholder="medium" value={customMedium} onChange={(e) => setCustomMedium(e.target.value)} className="text-xs" />
                <Input placeholder="campaign" value={customCampaign} onChange={(e) => setCustomCampaign(e.target.value)} className="text-xs" />
              </div>
            )}
          </div>

          <div className="flex gap-3 pt-2">
            <Button type="submit" className="gap-2">
              <PlusCircle className="h-4 w-4" /> Сохранить страницу
            </Button>
            <Button type="button" variant="outline" onClick={handleReset}>
              <RotateCcw className="h-4 w-4 mr-1" /> Сброс
            </Button>
          </div>
          <div className="text-xs text-slate-400 bg-slate-50 p-3 rounded-xl">
            <span className="font-medium">🔗 QR-ссылка:</span>{" "}
            <span className="font-mono text-blue-600">qrrun.ru/prem1</span>
            <div className="flex flex-wrap gap-2 mt-1">
              <span className="bg-white px-2 py-0.5 rounded-full text-[10px]">
                🏷️ теги: cashier_qr, loyalty
              </span>
            </div>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default CampaignForm;